import { Alert, Box, Button } from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import { PageHeader } from '@kangaroo/ui';
import { PAGE_ICONS } from '../../lib/pageIcons';

export function BillingRecoveryPage() {
  return (
    <Box sx={{ maxWidth: 560, mx: 'auto' }}>
      <PageHeader title="Account access" subtitle="Review account status and usage billing" icon={PAGE_ICONS.plans} mb={2} />
      <Alert severity="warning" sx={{ mb: 2 }}>
        Your team access is paused. A team owner must restore your account. Billing changes do not restore archived staff access.
      </Alert>
      <Button component={RouterLink} to="/billing" variant="outlined">Open Billing</Button>
    </Box>
  );
}
